import { mobileHyphensSetInstead } from './app-link'
import { numberWithCommas } from './inputs-helper'
import * as _ from 'lodash'
import { isPlatformBrowser } from '@angular/common'

// input fields global utils

/**
 * on focusout set mobile hyphens
 * @param elementId - target
 */
export function setMobileAfterChangeAllHyphens(elementId): void {
/*    if (!isPlatformBrowser(this.platformId)) {
      return;
   } */
  const inpt = document.getElementById(elementId)
  if (!inpt) {
    return
  }
  inpt.addEventListener('focusout', (event: any) => {
    const val = event.target.value
    if (!val || val.length === 0) {
      return
    }
    const newVal = mobileHyphensSetInstead(val)
    if (newVal && (val !== newVal)) {
      event.target.value = newVal
    }
  })
}

/**
 * transform amount to correct format
 * @param amount - input amount string / number
 * @returns updated amount with commas
 */
export function transformLoanAmountWithCommas(amount): string {
  if (!amount) { return '' }
  const newAmount = amount?.toString()?.startsWith('$') ? amount.slice(1) : amount.toString()
  return numberWithCommas(newAmount)
}



// 'number-input-home-div'

/**
 * set invalid class to element
 * @param blockId - element id
 */
export function setInvalidOn(blockId): void {
 /*     if (!isPlatformBrowser(this.platformId)) {
      return;
   } */
  const el = document.getElementById(blockId)
  el.classList.add('invalid')
}

/**
 * remove invalid class from element
 * @param blockId - element id
 */
export function removeInvalidOn(blockId): void {
 /*     if (!isPlatformBrowser(this.platformId)) {
      return;
   } */
  const el = document.getElementById(blockId)
  el.classList.remove('invalid')
}

/**
 * on focusout set invalid/valid class set
 * @param inputId - element id (input)
 * @param targetDivId - parent element id (div mainly)
 * @param validationF - function, if return false set invalid class
 */
export function addFocusOutEventSetInvalid(inputId, targetDivId, validationF): void {
  //    if (!isPlatformBrowser(this.platformId)) {
  //     return;
  //  }
  const inpt = document.getElementById(inputId)
  if (!inpt) {
    return
  }
  inpt.addEventListener('focusout', (event: any) => {
    const val = event.target.value
    if (!validationF(val)) {
      setInvalidOn(targetDivId)
      return
    }
    removeInvalidOn(targetDivId)

  })
}

/**
 * scan parents of element and check them
 * @param element - element, from which scanning starts
 * @param classList - provided classlist for scanning
 * @returns boolean if any in provided classList
 */
function scanParentsForClasses(element: any, classList: string[]): boolean {
  let currEl = element
  while (currEl.parentElement) {
    const interList: string[] = _.intersection(classList, currEl?.parentElement?.classList)
    if (interList.length > 0) {
      return true
    }
    currEl = currEl.parentElement
  }
  return false
}


export function checkIsInputArea(target: HTMLElement) {
  return (
    target.parentElement.classList.contains('input-area__active') ||
    target.parentElement.classList.contains('input-area__inactive') ||
    target.classList.contains('input-area__active') ||
    target.classList.contains('input-area__inactive')
  )
}

/**
 * manipulate with input-area's in form
 * @param event - event with target
 */
export function clickoutCloseInput(event: any): void {
  if (!event?.target?.parentElement?.classList) {
    return
  }
  const prohibitedClasses = ['modal', 'account-modal__wrapper']
  if (scanParentsForClasses(event?.target, prohibitedClasses)) { return }
  // console.log('close input clickout')
  let items = event.currentTarget.querySelectorAll('[class*=\'input-area\']')
  if (checkIsInputArea(event.target)) {
    const filteredEl = event.target.parentElement.querySelector('input')
    items = _.filter(items, (x) => !x.contains(filteredEl))
  }
  changeInputVisibleStateAll(items)
}

export function updateAreaActiveDependsOnValue(el: HTMLElement): void {
  if (!el) { return }
  if (el.querySelector('input')?.value?.length > 0) {
    el.classList.remove('input-area__inactive')
    el.classList.add('input-area__active')
  }
  else {
    el.classList.add('input-area__inactive')
    el.classList.remove('input-area__active')
  }
}
export function updateAreaActiveDependsOnElementValue(el: HTMLElement, value: any): void {
  if (!el) { return }
  // if (!value) { return }
  if (value?.length > 0) {
    el.classList.remove('input-area__inactive')
    el.classList.add('input-area__active')
  }
  else {
    el.classList.add('input-area__inactive')
    el.classList.remove('input-area__active')
  }
}

/**
 * for over all arrayData
 * if input is not empty set active, else inactive
 * @param arrayData - elements with input-area
 */
export function changeInputVisibleStateAll(arrayData: NodeList): void {
  Array.prototype.forEach.call(arrayData, (el) => {
    const inputField = el.querySelector('input')
    if (inputField) {
      // disabling it for form
      const controlName = inputField.getAttribute('formcontrolname')
      if (controlName) {
        return
      }
      updateAreaActiveDependsOnValue(el)
    }
  })
}

